import styled from 'styled-components';
import {
  ContentWrapperProps,
  ContainerProps,
} from '../types/SectionRedCampaignBanner.types';

export const ContainerWrapper = styled.div<ContainerProps>`
  background-color: var(--${props => props.backgroundColor});
  display: flex;
  justify-content: center;

  @media (max-width: 640px) {
    h2 {
      font-weight: 700;
    }

    p {
      font-weight: lighter;
    }

    [class^='Interactionstyle__BlankInteraction-sc'] {
      div {
        font-size: 18px;
        line-height: 28px;
      }
    }

    [class*='Buttonstyle__Button-sc-'] {
      margin: 0;
      width: 100% !important;
    }

    [class*='SimpleGridstyle__SimpleGridColumn-sc-'],
    [class*='CtaButtonRow___StyledDiv-'] {
      width: 100% !important;
    }
  }

  [class*='Containerstyle__Container-sc-'] {
    max-width: 1280px;
    width: 100%;
    margin: 32px;
    padding: 0;

    :focus {
      box-shadow: none;
    }

    @media (max-width: 640px) {
      margin: 16px;
    }

    @media only screen and (min-width: 1151px) {
      transition: all 0.2s ease-in-out;
      :hover {
        transform: scale(1.05);
      }
    }

    [class^='Containerstyle__ContainerContent-sc'] {
      display: flex;

      @media (max-width: 640px) {
        flex-direction: column-reverse;
      }
    }
  }
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: grid;
  width: 41%;
  padding: 30px 40px;
  text-align: start;

  @media (max-width: 640px) {
    padding: 30px 20px;
    width: 100%;

    p {
      margin: 20px 0;
    }

    [class^='Interactionstyle__BlankInteraction-sc'] {
      > div:first-child {
        transform: ${({ isRtl }) => (isRtl ? 'scaleX(-1)' : 'unset')};
      }

      :hover {
        color: unset;
        text-decoration: unset;

        svg {
          fill: #fff;
          stroke: #fff;
        }
      }
    }
  }

  [class*='LinkWithIconstyle__LinkWithIcon-sc-'] {
    margin: 0;
    &:hover {
      text-decoration: none;
      color: unset;
      svg {
        fill: #ffffff;
        stroke: #ffffff;
      }
    }
    &:focus {
      box-shadow: none;
    }
  }

  h2 {
    font-weight: 700;
    margin-top: 26px;

    @media (max-width: 640px) {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  p {
    font-weight: lighter;
  }

  [class*='LinkWithIconstyle__LinkWithIcon-sc-'] {
    margin: 0;
    &:hover {
      text-decoration: none;
      color: unset;
      svg {
        fill: #ffffff;
        stroke: #ffffff;
      }
    }
    &:focus {
      box-shadow: none;
    }
  }

  @media (min-width: 768px) {
    [class^='Interactionstyle__BlankInteraction-sc'] {
      div {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }

  [class^='Interactionstyle__BlankInteraction-sc'] {
    align-self: flex-end;

    > div:first-child {
      transform: ${({ isRtl }) => (isRtl ? 'scaleX(-1)' : 'unset')};
    }

    :hover {
      color: unset;
      text-decoration: unset;

      svg {
        fill: #fff;
        stroke: #fff;
      }
    }
  }

  [class*='Buttonstyle__Button-sc-'] {
    margin: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 59%;

  @media (max-width: 640px) {
    width: 100%;
  }

  .gatsby-image-wrapper {
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-inline-end: -3px;
    border-radius: 0 6px 6px 0;

    @media (max-width: 640px) {
      border-radius: 5px 5px 0 0;
    }
  }
`;

export const BetaLabel = styled.div`
  @media (max-width: 640px) {
    display: none;
  }

  background-color: #00697c;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 13px;
  width: fit-content;
  height: fit-content;

  span {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
  }
`;
